<!-- 引导弹窗支持opentag -->
<template>
  <Modal
    class="modal-guide modal-guide-open-tag"
    :name="modalName"
    :show-close="false"
    :cover-closeable="false"
    :close-btn-handler="handleCloseBtn"
    @modalClose="handleCloseBtn"
  >
    <div
      slot="modal-content"
      class="content"
    >
    <div class="guide-body" :class="{'show': show}">
      <div class="guide-content">打开高德地图查看原文</div>
      <div class="guide-footer">
        <div class="guide-btn" @click="handleCancelBtn">取消</div>
        <div class="guide-btn" @click="openAmap">
          <WXLaunchBtn
            @error="handleWxLunchBtnError"
            @wxClick="handleWxClick"
            :schema="schema"
          >
            <template slot="default">
              <div class="open-btn-in" id="openBtn" @click="callNativeAmap">打开</div>
            </template>
          </WXLaunchBtn>
          继续
        </div>
      </div>
    </div>
    </div>
  </Modal>
</template>

<script>
/* eslint prefer-destructuring:0, max-len:0 */
import { webviewInfo, log } from '@ali/amap-lib';
import getShareLogParams from '@ali/amap-call-native/getShareLogParams';
import WXLaunchBtn from './WXLaunchBtn.vue';

import Modal from './Modal.vue';

export default {
  name: 'GuideOpenTag',
  components: {
    Modal,
    WXLaunchBtn
  },
  props: {
    // schema跳转地址
    schema: {
      type: String,
      default: '',
    },
    // 页面类型
    pageType: {
      type: String,
      default: '',
    },
  },
  created() {
    if (!webviewInfo.isInAmap()) {
      const params = getShareLogParams({
        page_type: this.pageType
      });
      console.log(params, '曝光=====埋点全链路参数');
      // eslint-disable-next-line no-undef
      window?.AmapTracker?.recordEXP('call.call_amap', {
        params: {
          ...params,
          share_channelSpm: this.share_channelSpm
        },
      });
    }
    setTimeout(() => {
      this.show = true;
    }, 50);
  },
  mounted() {

  },
  data() {
    return {
      modalName: 'showGuideOpenTag',
      show: false,
    };
  },
  methods: {
    handleCloseBtn() {
      this.$emit('close');
    },
    handleCancelBtn() {
      log.log('B002', {
        type: this.id,
        other: 1
      });
      this.handleCloseBtn();
    },
    openAmap() {
      // callFn();
      log.log('B001', {
        type: this.id,
        other: 1
      });
      this.handleCloseBtn();
      this.$emit('goAmap');
    },
    callNativeAmap() {
      this.openAmap();
    },
    // open-tag点击需要埋点
    handleWxClick() {
      this.$emit('openAmapLog', 'opentag');
    },
    // 如果wx launch出现错误的话，就使用原来的逻辑
    handleWxLunchBtnError() {
      this.openAmap();
    }
  }
};
</script>

<style lang="scss">
@import "../../../common/css/common-mixin";

.modal-guide.modal-guide-open-tag {
  background: rgba(0, 0, 0, .5);
  .content {
    width: rpx(527);
    height: rpx(694);
    .message {
      height: rpx(524);
      overflow-y: scroll;
      color: #545353;
      font-size: rpx(26);
      line-height: rpx(40);
      color: #545353;
      text-align: justify;
      /*解决ios上滑动不流畅*/
      -webkit-overflow-scrolling: touch;
      .mes-cont {
        min-height: calc(100% + 1px);
        margin-top: 0;
      }
      h3 {
        font-size: rpx(28);
        line-height: rpx(40);
        text-align: center;
        margin: 0;
        margin-bottom: rpx(10);
      }
      div {
        font-size: rpx(28);
        margin-top: rpx(20);
      }
      p {
        font-size: rpx(26);
        line-height: rpx(40);
        color: #545353;
        padding-bottom: 0 !important;
        margin-bottom: rpx(10);
      }
    }
  }
}
.message::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
 .guide-body {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 5.4rem;
    height: auto;
    margin-left: -2.7rem;
    background: #fff;
    font-size: 0.36rem;
    color: #212121;
    line-height: 1.5;
    text-align: center;
    word-break: break-all;
    opacity: 0;
    transition: all 0.2s ease-in-out;
    -webkit-transition: all 0.2s ease-in-out;
    transform: translateY(-50%) scale(0.8);
    -webkit-transform: translateY(-50%) scale(0.8);
    border-radius: 0.32rem;
}
.show{
  opacity: 1;
    transform: translateY(-50%) scale(1);
    -webkit-transform: translateY(-50%) scale(1);
}
.guide-content {
    font-size: 0.32rem;
    font-weight: bold;
    padding: 0.48rem;
}
.guide-footer {
    display: -webkit-box;
    display: flex;
}
.guide-btn{
  font-size: 0.32rem;
    line-height: 0.94rem;
    padding: 0;
    height: 0.94rem;
    -webkit-box-flex: 1;
    flex: 1;
    height: 1.1rem;
    line-height: 0.9rem;
    padding: 0.1rem;
    border-top: 1px solid #e2e2e2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #4287FF;

}
.guide-btn:first-child{
  color: #333;
}
 .guide-btn:not(:nth-of-type(1)) {
    border-left: 1px solid #e2e2e2;
}

</style>
